import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_LINE } from '../../../utils/constants/Map';
import { colors } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import { PAGE_NAME } from 'utils/constants';
const Polyline = ({
  lineConfig,
  markers,
  maps,
  map,
  strokeColor = colors.red,
  dashed,
  strokeWeight = 2,
  polylineRef,
  polygonData,
  layers,
  switchedLayer = [],
  distress,
  detailOpen,
}) => {
  const lineSymbol = {
    ...DEFAULT_LINE,
    strokeColor,
  };
  useEffect(() => {
    // do not draw if the layer is switched off
    if (switchedLayer.includes(polygonData?.layer)) {
      return undefined; // has to return undefined as it throws destroy is not a function
      // TypeError: destroy is not a function
    }
    const polyline = new maps.Polyline({
      path: markers,
      map: map,
      id: polygonData?.id,
      layer: polygonData?.layer,
      strokeOpacity: dashed ? 0 : 1,
      strokeColor,
      fillOpacity: 0,
      strokeWeight,
      geodesic: false,
      icons: lineConfig
        ? [
            {
              icon: { strokeColor, ...lineConfig.symbol },
              ...lineConfig.props,
            },
          ]
        : dashed
        ? [
            {
              icon: lineSymbol,
              offset: '0',
              repeat: '10px',
            },
          ]
        : null,
    });
    const animateCircle = line => {
      let count = 0;

      window.setInterval(() => {
        count = (count + 1) % 200;

        const icons = line.get('icons');
        if (!icons) return;
        icons[0].offset = `${count / 2}%`;
        line.set('icons', icons);
      }, 100);
    };
    // only animate if it is distress, detail panel is open and points are connecting emergency between two points
    polyline &&
      distress &&
      detailOpen &&
      polygonData?.layer === PAGE_NAME.EMERGENCY &&
      animateCircle(polyline);

    if (polylineRef?.current?.[polygonData.layer]) {
      polylineRef.current[polygonData.layer].push(polyline);
    }
    if (polylineRef?.current) {
      Object.assign(polylineRef.current, {
        [polygonData.layer]: [],
      });
      polylineRef.current[polygonData.layer].push(polyline);
    }

    return () => {
      polyline.setMap(null);
    };
  }, [
    markers,
    lineSymbol,
    map,
    maps,
    dashed,
    strokeColor,
    lineConfig,
    strokeWeight,
  ]);
  // remove the polyline layers
  /* eslint-disable consistent-return */
  useEffect(() => {
    if (!polylineRef?.current) {
      return undefined;
    }
    if (
      !isEmpty(polylineRef.current) &&
      Object.keys(layers).some(k => !layers[k])
    ) {
      switchedLayer.forEach(f => {
        if (!polylineRef.current[f]) {
          polylineRef.current[f] = [];
        }
        const copy = [...polylineRef.current[f]];
        copy.forEach((poly, i) => {
          if (f === poly.layer) {
            poly.setVisible(false);
            polylineRef.current[f].splice(i, 1);
          }
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layers, map, markers, polylineRef]);

  // if (markers.length > 1) {
  //   const bounds = new maps.LatLngBounds();
  //   for (const marker of markers) {
  //     bounds.extend(new maps.LatLng(marker.lat, marker.lng));
  //   }
  //   const center = bounds.getCenter();

  //   const position = {
  //     latitude: center.lat(),
  //     longitude: center.lng(),
  //   };

  //   map.setCenter(new maps.LatLng(position.latitude, position.longitude));

  //   if (content) {
  //     return (
  //       <InfoWindow
  //         maps={maps}
  //         map={map}
  //         position={position}
  //         content={content}
  //         type="text"
  //       />
  //     );
  //   }
  // }
  return null;
};

Polyline.propTypes = {
  strokeColor: PropTypes.string,
  dashed: PropTypes.bool,
  markers: PropTypes.array,
  switchedLayer: PropTypes.array,
  maps: PropTypes.object,
  map: PropTypes.object,
  content: PropTypes.string,
  lineConfig: PropTypes.object,
  polygonData: PropTypes.object,
  layers: PropTypes.object,
  strokeWeight: PropTypes.number,
  distress: PropTypes.bool,
  detailOpen: PropTypes.bool,
  polylineRef: PropTypes.oneOfType([
    PropTypes.shape({ current: PropTypes.any }),
  ]),
};

export default Polyline;
